import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {AccountDialogService} from "../../services/account-dialogs-service.service";

export class AccountVehicleInfoCtrl implements IController {

  account: AccountModel;
  selectedVehicle: any;
  vehicleIndex: any;
  onUpdate: Function;

  /* @ngInject */
  constructor(private accountDialogService: AccountDialogService) {
  }

  editVehicleInfo(event) {
    this.accountDialogService.editVehicleInfo(event, this.account, this.vehicleIndex)
      .then((updatedAccount) => {
        this.sendForUpdate(updatedAccount);
      });
  }

  editVehicleRegistration(event) {
    this.accountDialogService.editVehicleRegistration(event, this.account, this.vehicleIndex)
      .then((updatedAccount) => {
        this.sendForUpdate(updatedAccount);
      });
  }

  editVehicleInsurance(event) {
    this.accountDialogService.editVehicleInsurance(event, this.account, this.vehicleIndex)
      .then((updatedAccount) => {
        this.sendForUpdate(updatedAccount);
      });
  }

  editVehicleImage(event) {
    this.accountDialogService.editVehicleImage(event, this.account, this.vehicleIndex)
      .then((updatedAccount) => {
        this.sendForUpdate(updatedAccount);
      });
  }

  editInspectionDocument(event) {
    this.accountDialogService.editInspectionDocument(event, this.account, this.vehicleIndex)
      .then((updatedAccount) => {
        this.sendForUpdate(updatedAccount);
      });
  }

  private sendForUpdate(updatedAccount) {
    if (!_.isUndefined(updatedAccount)) {
      this.onUpdate({account: updatedAccount})
    }
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('accountVehicleInfo', {
    bindings: {
      account: '<',
      selectedVehicle: '<',
      vehicleIndex: '<',
      onUpdate: '&'
    },
    template: require('./account-vehicle-info.html').default,
    controller: AccountVehicleInfoCtrl
  });
